import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const token = import.meta.env.VITE_SANITY_API_TOKEN;
console.log('Sanity Environment Variables:', {
  projectId: import.meta.env.VITE_SANITY_PROJECT_ID,
  dataset: import.meta.env.VITE_SANITY_DATASET,
  token: import.meta.env.VITE_SANITY_API_TOKEN ? 'Token exists' : 'No token found',
});

if (!import.meta.env.VITE_SANITY_API_TOKEN) {
  console.error('Sanity API token is missing. Please check your .env file.');
}

export const client = createClient({
  projectId: import.meta.env.VITE_SANITY_PROJECT_ID,
  dataset: import.meta.env.VITE_SANITY_DATASET || 'production',
  apiVersion: '2024-03-19',
  useCdn: true,
  token: token,
  ignoreBrowserTokenWarning: true,
  perspective: 'published',
  stega: false,
});

const builder = imageUrlBuilder(client);

export function urlFor(source: any) {
  return builder.image(source);
} 